import { Component } from '@angular/core';

@Component({
    selector: 'app-invalid-permissions',
    templateUrl: './invalid-permissions.component.html',
    styleUrls: ['./invalid-permissions.component.scss'],
    standalone: false
})
export class InvalidPermissionsComponent  {

  constructor() {}
  
}